export default __webpack_public_path__ + "static/media/hand.58e52d6d.webp";